
export function formatPhoneForDisplay(phone?: string | null): string {
  if (!phone) return '';

  const cleanedValue = phone.replace(/\D/g, '');

  if (cleanedValue.length !== 10) return phone;

  return `(${cleanedValue.slice(0, 3)}) ${cleanedValue.slice(3, 6)}-${cleanedValue.slice(6, 10)}`;
}

// A phone number is valid when it is empty (no phone provided — same rule the
// email uses: only validate when a value is present) or has exactly 10 digits,
// i.e. matches the "___-___-____" mask. Anything else (partial, or 11+ digits)
// is invalid and must block saving.
export function isValidPhoneNumber(phone?: string | null): boolean {
  const digits = (phone ?? '').replace(/\D/g, '');
  return digits.length === 0 || digits.length === 10;
}
